module.exports = "assets/img/architecture_en_belgique.jpg";